module.exports = __webpack_public_path__ + "static/img/case_tab_16.60c9234.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_tab_16.png
// module id = yC8c
// module chunks = 34